import React from 'react';

class Mantra_9N2_Canvas extends React.Component {
    constructor() {
        super();

    }




    render() {
        const { message, module_name } = this.props;


        return (
            <section className="canvas_section mantra9n2_prev_section setdiv_canvas" id={"canvas_generate_" + module_name}>
                <img src="/assets/img/Mantra9Activity-02.jpg" className="m18_cirt" />
                <p className="mantra9n2_new_p">{message}</p>

            </section>
        )
    }
}

export default Mantra_9N2_Canvas;